import { ResponsiveGrid } from '@alifd/next';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import BAEventRecord from './components/BAEventRecord';
import BAList from './components/BAList';
import BARecord from './components/BARecord';

const { Cell } = ResponsiveGrid;

const BA = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="BA列表"
        breadcrumbs={[
          {
            name: 'BA系統',
          },
          {
            name: 'BA列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <BAList />
      <h1>BA事件記錄</h1>
      <BAEventRecord />
      <h1>BA操作記錄</h1>
      <BARecord />
    </Cell>
  </ResponsiveGrid>
);

export default BA;
